import adaloLogoType from '../App/logo.svg'

import './Onboarding.scss'

const AdaloLogotype = (): JSX.Element => (
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  <img className="adalo-logotype" src={adaloLogoType} alt="Adalo logo" />
)

export default AdaloLogotype
